import { render, staticRenderFns } from "./MbMonograph.vue?vue&type=template&id=736a8b16&scoped=true&"
import script from "./MbMonograph.vue?vue&type=script&lang=js&"
export * from "./MbMonograph.vue?vue&type=script&lang=js&"
import style0 from "./MbMonograph.vue?vue&type=style&index=0&id=736a8b16&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a8b16",
  null
  
)

export default component.exports